<template>
  <div id="site-footer" data-qa="site-footer" class="site-footer">
    <section class="site-footer__payment-systems" v-if="footerCmsResourcesLocal && footerCmsResourcesLocal.paymentBlock">
      <payment-systems :resource="footerCmsResourcesLocal.paymentBlock"/>
    </section>
    <section class="site-footer__links">
      <div class="site-links">
        <div class="site-links__info">
          <exchange-rates v-if="currencyRateInfo" class="site-links__exchange" :currency-rate-info="currencyRateInfo"/>
          <tour-operator-office-contacts class="site-links__contacts"
                                         :tour-operator-office-contacts="tourOperatorOfficeContactsLocal"/>
          <social-links v-if="!!footerCmsResourcesLocal && !!footerCmsResourcesLocal.socialBlock"
                        :resource="footerCmsResourcesLocal.socialBlock"
                        class="site-links__social"
          ></social-links>
        </div>
        <footer-menu v-if="!footerMenuFetchAttemptsExceeded" :footer-menu="footerMenuLocal"/>
        <div v-else>"FOOTER-MENU" cms menu is missing.</div>
      </div>
    </section>
    <section class="site-footer__legal" v-if="!!footerCmsResourcesLocal">
      <div v-if="!!footerCmsResourcesLocal.legalBlock" class="legal">
        <div v-html="footerCmsResourcesLocal.legalBlock"></div>
      </div>
    </section>
  </div>
</template>

<script>
import ExchangeRates from "./components/FooterExchangeRatesComponentDesktop.vue";
import TourOperatorOfficeContacts from "./components/FooterTourOperatorOfficeContactsComponentDesktop.vue";
import FooterMenu from "./components/FooterMenuComponentDesktop.vue";
import SocialLinks from "./components/FooterSocialLinksComponentDesktop.vue";
import PaymentSystems from "./components/FooterPaymentSystemsComponentDesktop.vue";
import Base from "./FooterAppBase";

export default {
  inheritAttrs: false,
  extends: Base,
  components: {
    ExchangeRates,
    TourOperatorOfficeContacts,
    FooterMenu,
    SocialLinks,
    PaymentSystems,
  },
};
</script>

<style lang="scss" scoped>
@mixin stretch-block {
  width: 1128px;
  margin: 0 auto;
}

.site-footer {
  background-color: var(--main-10);
  color: var(--white);
  
  > * + * {
    border-top: 1px solid var(--main-30);
  }
}

.site-footer__payment-systems {
  > * {
    @include stretch-block;
  }
}

.site-footer__links {
  padding-block: 20px;

  > * {
    @include stretch-block;
  }
}

.site-links {
  display: flex;
  flex-flow: row nowrap;
  gap: 24px;
  font-size: 16px;
  line-height: 20px;

  > :nth-child(1) {
    flex: 1 1 25%;
  }

  > :nth-child(2) {
    flex: 1 1 75%;
    display: flex;
    flex-flow: row nowrap;
    gap: 24px;
  }
}

.site-links__info {
  > * + * {
    margin-top: 20px;
  }
}

.site-footer__legal {
  > * {
    @include stretch-block;
  }
}

.legal {
  padding-block: 15px;
  font-size: 16px;
  line-height: 20px;
  color: var(--second-50);
}
</style>
